module.exports = __webpack_public_path__ + "img/4064003070.a3cb9c17.jpg";